// Import Swiper and modules
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper/core';
import axios from 'axios'
import $ from "jquery";
// // Install modules
// Swiper.use([Navigation, Pagination, Scrollbar]);

// // Now you can use Swiper
// const swiper = new Swiper('.swiper-container', {
//   speed: 500,
//   navigation: {
//   },
// });

const scrollOffsetDesktop = 110;
const scrollOffsetMobile = 90;
// 幅が768px以上のビューポートをターゲットとするメディアクエリを作成
const mediaQueryIsDesktop = window.matchMedia('(min-width: 768px)')
// 幅が1240px未満のビューポートをターゲットとするメディアクエリを作成
const mediaQueryIsMobileAndLaptop = window.matchMedia('(max-width: 1239px)')

// safariだけwebfontの縦書きが崩れる問題対応のためUA判別、今後廃止されるかもしれないのでできるだけ使わない方向
window.addEventListener('DOMContentLoaded', () => {
  let elBody = document.querySelector('body');
  var userAgent = window.navigator.userAgent.toLowerCase();
  console.log(userAgent);
  if (userAgent.indexOf('safari') != -1) {
    console.log('ブラウザはSafariです');
    elBody.classList.add('is_ua_safari');
  }
});
$(() => {
  $('#line-banner-pc .close-button').on('click', (event: JQuery.Event) => {
    $('#line-banner-pc').addClass('is_hide')
  })
  $('#paraspolab-banner-pc .close-button').on('click', (event: JQuery.Event) => {
    $('#paraspolab-banner-pc').addClass('is_hide')
  })
  $('#back-to-top').on('click', (event: JQuery.Event) => {
    $('body,html').animate({ scrollTop: 0 }, 1000);
  })
});


$(() => {
  if (mediaQueryIsMobileAndLaptop.matches) {
    let elGnav = $('#ctl-g-nav');
    elGnav.find('.has-sub-group').on('click', (event: JQuery.ClickEvent) => {
      event.preventDefault();
      let target = $(event.currentTarget);
      target.toggleClass('is_open');
      target.next('.nav-sub-group').slideToggle();
    })

    elGnav.find('a[href*="#"]').on('click', (event: JQuery.ClickEvent) => {
      event.preventDefault();
      let target = $(event.currentTarget);
      console.log(target.attr('href'));
      location.href = target.attr('href');
      console.log(location.hash);
      var scrollHeight = $(location.hash).offset().top - scrollOffset;
      console.log(scrollHeight);
      console.log(scrollOffset);
      $('html,body').animate({ scrollTop: scrollHeight }, 0);
      elGnav.removeClass('is_open');
      $('#ctl-menu-button').removeClass('is_open');
      // navが隠れたらサブメニュー閉じる
      elGnav.find('.nav-label').removeClass('is_open');
      elGnav.find('.nav-sub-group').css('display','none');

    });
  }
});
const initMobileGlobalNav = () => {
  let scrollTop: number;
  let elGlobalNav = <HTMLElement>document.getElementById('ctl-g-nav');
  let elMenuButton = <HTMLElement>document.getElementById('ctl-menu-button');
  elMenuButton.addEventListener('click', (event) => {
    elMenuButton.classList.toggle('is_open');
    console.log('is_open' in elGlobalNav.classList);
    if (elMenuButton.classList.contains('is_open')) {
      elGlobalNav.classList.add('is_open');
      console.log('noScroll');
      scrollTop = document.documentElement.scrollTop;
    } else {
      console.log('returnScroll');
      window.scrollTo(0, scrollTop);
      elGlobalNav.classList.remove('is_open');
    }
  });

  // elGlobalNav.querySelectorAll('a').forEach((element) => {
  //   element.addEventListener('click', (ev: MouseEvent) => {
  //     ev.currentTarget.attr

  //   });

  // });
}

// (max-width: 1240px - 1px)

$(() => {
  let $app_calendar_area = $('#app_calendar_area');
  $app_calendar_area.find('.calendar-tab-label').on('click', (event: JQuery.ClickEvent) => {
    let $tabLabel = $(event.currentTarget);
    let calendaName = $tabLabel.attr('data-target-tab-id');
    if (!$tabLabel.hasClass('is_active')) {
      $app_calendar_area.find('.calendar-tab-label').removeClass('is_active');
      $tabLabel.addClass('is_active');
    }
    let $calendaName = $(`#${calendaName}`);
    if (!$calendaName.hasClass('is_active')) {
      $app_calendar_area.find('.calendar-tab-item').removeClass('is_active');
      $calendaName.addClass('is_active');
    }
  });

  $('#calendar_toggle').on('click', (event: JQuery.ClickEvent) => {
    $(event.target).parent().toggleClass('is_show');
  });
});

$(() => {
  let accordionTitle = $('.sidebar-link-list-wrap.type_accordion').prev();
  if (accordionTitle.length == 0) {
    return;
  }
  accordionTitle.addClass('accordion-title');
  accordionTitle.each((index, element) => {
    console.log($(element));

    if ($(element).next().hasClass('is_open')) {
      $(element).addClass('is_open');
    } else {
      $(element).removeClass('is_open');
    }
  });
  accordionTitle.on('click', (event: JQuery.ClickEvent) => {
    let target = $(event.currentTarget);
    target.next().toggleClass('is_open');

    if (target.next().hasClass('is_open')) {
      target.addClass('is_open');
    } else {
      target.removeClass('is_open');

    }
  })

});

// リサイズ処理を登録 リサイズ時はリサイズが連続で発生するので最後のイベントが終わったタイミングでコールバック実行
const addResizeAction = (callback: () => void) => {

  let timeoutID = 0;
  let delay = 500;

  window.addEventListener("resize", () => {
    console.log('resize');
    clearTimeout(timeoutID);
    // window.にしないとnodeのsetTimeoutと間違われる
    timeoutID = window.setTimeout(() => {
      console.log('setTimeout');
      callback();
    }, delay);
  }, false);
};

window.addEventListener('load', (event) => {
  fitSvfgBorder();
  addResizeAction(fitSvfgBorder);
});

let fitSvfgBorder = () => {
  document.querySelectorAll('.ctl-svg-fit').forEach((svgFit: HTMLElement) => {
    let width = svgFit.offsetWidth;
    let height = svgFit.offsetHeight;
    let svg = svgFit.querySelector('svg');
    let rect = svgFit.querySelector('rect');
    console.log(svg);
    console.log(rect);
    // 描画領域を枠のサイズに合わせる
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    // 点の幅が2なのではみ出ないようにrectから2引く
    rect.setAttribute('width', `${width - 2}`);
    rect.setAttribute('height', `${height - 2}`);
  })
}



$(() => {
  class InstagramResponseItem {
    id: string;
    caption: string;
    permalink: string;
    media_url: string;
    thumbnail_url: string;
  }

  class InstagramResponse {
    data: InstagramResponseItem[];
  }

  let drawInstagramList = (res: InstagramResponse) => {
    console.log("drawInstagramList ", res)
    if(!res?.data){
      return;
    }
    let $app_instagram_feed = $('#app_instagram_feed');
    let max_display_num = 6;
    let count = 0;
    if ($app_instagram_feed.length) {
      res.data.forEach((item, index) => {
        if (count >= max_display_num) {
          return;
        }

        let media_url = item.thumbnail_url ? item.thumbnail_url : item.media_url;
        if(media_url){
          $app_instagram_feed.append(`<li class="front-hero-instagram-content-item"><a href="${item.permalink}" target="_brank"><img src="${media_url}" alt="${item.caption}"></a></li>`);
          count++;
        }
      });
    }
  }

  axios.get('/api_cache/instagram/feed.json').then(function (response) {
    // handle success
    console.log(response.data);
    const res = response.data as InstagramResponse;
    console.log(res);
    drawInstagramList(res)
  });

});

$(() => {
  console.log($("#blog-main-content .is-style-heading-type_07,#blog-main-content .is-style-heading-type_08"));
  $("#blog-main-content .is-style-heading-type_07,#blog-main-content .is-style-heading-type_08").append('<span class="border-h"></span><span class="border-v"></span>')

});
window.addEventListener('DOMContentLoaded', () => {
  initMobileGlobalNav();
  initJobDescriptionTab();
  initStaffTab();
});


const initJobDescriptionTab = () => {
  let tabLabels = document.querySelectorAll("[data-job_description-target-id]");
  if (tabLabels.length == 0) {
    return;
  }
  let query = getQuery();
  console.log(query);
  console.log(query['tab']);

  let isTabSelected = false;
  if (query['tab']) {
    console.log(`[data-slug=${query['tab']}]`);
    let elSelectedTab = <HTMLElement>document.querySelector(`[data-slug="${query['tab']}"]`);
    if (elSelectedTab) {
      changeActiveJobDescriptionTab(elSelectedTab);
      isTabSelected = true;
    }
  }
  // 何も選択されてない場合はデフォルトとして1番目のタブを選択
  if (!isTabSelected) {
    changeActiveJobDescriptionTab(tabLabels[0] as HTMLElement)
  }

  tabLabels.forEach((tabLabel) => {
    tabLabel.addEventListener('click', (event) => {
      let elTabLabel = event.currentTarget as HTMLElement;
      changeActiveJobDescriptionTab(elTabLabel)
    });
  });
}

const changeActiveJobDescriptionTab = (elTabLabel: HTMLElement) => {
  // 前回選択されたタブからis_activeを取りのぞく
  removeSiblingActiveClass(elTabLabel);
  elTabLabel.classList.add('is_active');
  let targetId = elTabLabel.dataset.job_descriptionTargetId;
  let elTabTargetFullTime = <HTMLElement>document.getElementById(`job_description-tab-full_time-${targetId}`);
  removeSiblingActiveClass(elTabTargetFullTime);
  elTabTargetFullTime.classList.add('is_active');
  let elTabTargetPartTime = <HTMLElement>document.getElementById(`job_description-tab-part_time-${targetId}`);
  removeSiblingActiveClass(elTabTargetPartTime);
  elTabTargetPartTime.classList.add('is_active');
}

// 前回選択されてた要素についたis_activeを削除
const removeSiblingActiveClass = (currentElement: HTMLElement) => {
  console.log('currentElement.parentNode');
  console.log(currentElement.parentNode);
  (currentElement.parentNode as HTMLElement).dataset.tabSelected = currentElement.dataset.commonButtonTabTarget;
  let activeElement = currentElement.parentNode.querySelector('.is_active');
  if (activeElement) {
    activeElement.classList.remove('is_active');
  }
}

const initStaffTab = () => {
  let tabLabels = document.querySelectorAll("[data-common-button-tab-target]");
  if (tabLabels.length == 0) {
    return;
  }
  console.log(tabLabels);
  let tabContents = document.querySelectorAll('.common-button-tab-content');
  let query = getQuery();
  console.log(query);
  console.log(query['tab']);
  let isTabSelected = false;
  if (query['tab']) {
    console.log(`[data-slug=${query['tab']}]`);
    //   console.log(`tab-${query['tab']}`);
    let elSelectedTab = <HTMLElement>document.querySelector(`[data-common-button-tab-target="tab-${query['tab']}"]`);
    console.log('elSelectedTab');
    console.log(elSelectedTab);
    if (elSelectedTab) {
      changeActiveCommonButtonTab(elSelectedTab);
      isTabSelected = true;
    }

  }

  console.log('tabLabels');
  console.log(tabLabels);
  // 何も選択されてない場合はデフォルトとして1番目のタブを選択
  if (!isTabSelected) {
    changeActiveCommonButtonTab(tabLabels[0] as HTMLElement)
  }
  tabLabels.forEach((tabLabel) => {
    tabLabel.addEventListener('click', (event) => {
      changeActiveCommonButtonTab(event.currentTarget as HTMLElement);
    });
  });
}

const removeClosestActiveClass = (currentElement: HTMLElement) => {
  let activeElement = currentElement.closest('.is_active');
  if (activeElement) {
    activeElement.classList.remove('is_active');
  }
}

const changeActiveCommonButtonTab = (elTabLabel: HTMLElement) => {
  console.log('elTabLabel');
  console.log(elTabLabel);
  // 前回選択されたタブからis_activeを取りのぞく
  removeSiblingActiveClass(elTabLabel);
  elTabLabel.classList.add('is_active');
  let targetId = elTabLabel.dataset.commonButtonTabTarget;
  let elTabTarget = <HTMLElement>document.getElementById(targetId);
  console.log(elTabTarget);
  removeSiblingActiveClass(elTabTarget);
  elTabTarget.classList.add('is_active');
}

const getQuery = () => {
  let queryString = window.location.search;
  console.log(queryString);
  let queryObject = new Object();
  if (queryString) {
    queryString = queryString.substring(1);
    let parameters = queryString.split('&');

    for (var i = 0; i < parameters.length; i++) {
      let element = parameters[i].split('=');
      let paramName = decodeURIComponent(element[0]);
      let paramValue = decodeURIComponent(element[1]);
      queryObject[paramName] = paramValue;
    }
  }
  return queryObject;
}



let setScrollOffset = () => {
  if (mediaQueryIsDesktop.matches) {
    scrollOffset = scrollOffsetDesktop;
  } else {
    scrollOffset = scrollOffsetMobile;
  }
}

// メディアクエリがtrueかどうかをチェック

let scrollOffset = scrollOffsetDesktop;

$(window).on('load', () => {
  if (mediaQueryIsDesktop.matches) {
    scrollOffset = scrollOffsetDesktop;
  } else {
    scrollOffset = scrollOffsetMobile;
  }

  var hash = $(location).attr('hash');
  console.log(`hash: ${hash}`)
  if (hash) {
    var target = $(hash).offset().top - scrollOffset;
    console.log(`targetScroll: ${target}`)
    $('html,body').animate({ scrollTop: target }, 0);
  }
  addResizeAction(setScrollOffset);
});
